import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
render(<ErrorBoundary data-id="element-793">
    <App data-id="element-794" />
  </ErrorBoundary>, document.getElementById('root'));